"use strict";

require("core-js/modules/esnext.string.replace-all.js");
require("core-js/modules/esnext.string.replace-all.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAccents = void 0;
exports.replaceAll = replaceAll;
exports.sanitizeURL = sanitizeURL;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");

/**
 * Replace all occurrences of a string with another one.
 * @param haystack
 * @param needle
 * @param replacement
 * @returns {*}
 */
function replaceAll(haystack, needle, replacement) {
  while (haystack.indexOf(needle) >= 0) {
    haystack = haystack.replace(needle, replacement);
  }
  return haystack;
}
/**
 * Remove any weird characters from the url. Lowercase.
 * @param url
 * @returns {*}
 */

function sanitizeURL(url) {
  url = url.toString().toLowerCase();
  url = removeAccents(url);
  url = replaceAll(url, '-/ ', '-');
  url = replaceAll(url, '   ', '-');
  url = replaceAll(url, '  ', '-');
  url = replaceAll(url, ' ', '-');
  url = replaceAll(url, ', ', '-');
  url = replaceAll(url, ',', '-');
  url = replaceAll(url, '(', '');
  url = replaceAll(url, '(', '');
  url = replaceAll(url, ')', '');
  url = url.replace(/[^a-z0-9-_]/gi, '');
  url = replaceAll(url, '----', '-');
  url = replaceAll(url, '---', '-');
  url = replaceAll(url, '--', '-');
  return url;
}
/**
 * Remove Accents from a string.
 * @param str
 * @returns {string}
 */

var removeAccents = function removeAccents(str) {
  var accents = {
    a: 'àáâãäåæ',
    c: 'ç',
    e: 'èéêëæ',
    i: 'ìíîï',
    n: 'ñ',
    o: 'òóôõöø',
    s: 'ß',
    u: 'ùúûü',
    y: 'ÿ'
  };
  var newStr = '';
  for (var char in str) {
    var continueFlag = false;
    for (var accent in accents) {
      if (accents[accent].includes(str[char])) {
        newStr += accent;
        continueFlag = true;
        break;
      }
    }
    if (continueFlag) continue;
    newStr += str[char];
  }
  return newStr;
};
exports.removeAccents = removeAccents;